import { Type } from "class-transformer";
import { observable } from "mobx";
import type { EntityValidationRules } from "../services/validationService";
import Invitation from "./invitation";
import User, { BaseUserValidationRules } from "./user";

export default class ExternalUser extends User {
  @observable allowedProviders: string[] = [];
  @Type(() => Date)
  @observable
  invitationValidUntil?: Date;
  @Type(() => Invitation)
  invitation?: Invitation;
}

export const ExternalUserValidationRules: EntityValidationRules<ExternalUser> = {
  ...BaseUserValidationRules,
  invitationValidUntil: {
    required: true,
  },
};

export function isExternalUser(user: User | ExternalUser): user is ExternalUser {
  return user.invitation !== undefined;
}
